export default __webpack_public_path__ + "static/media/8.a157fb88.png";